<template>
  <div class="height-100-p" id="layout-search-summary-section">
    <el-table
      :data="layout.list"
      id="layout-data-list"
      size="mini"
      tooltip-effect="dark"
      sortable
      class="dark-blue-table"
      :empty-text="$t('common.notAbleToFindRecords')"
      stripe
    >
      <el-table-column
        prop="day"
        :label="$t('layout.date')"
        :min-width="5"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.layoutDate | moment(dateDisplayFormat) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="layoutTemplate"
        :label="$t('layout.layoutTemplate')"
        :min-width="5"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.dayName.concat(' - ').concat(scope.row.code).concat(' - ').concat(scope.row.name) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="positions"
        :label="$t('layout.positionsAssigned')"
        :min-width="5"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.positionsAssigned }}</span>
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('layout.active')"
        :min-width="5"
        align="center"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="scope.row.activeForReceiving || scope.row.activeForOutbound"
            :content="isActiveTooltipText(scope.row)"
            class="item"
            effect="dark"
            placement="top-start"
          >
            <i class="el-icon-success green-success"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.options')" :min-width="4" align="center">
        <template slot-scope="scope">
          <view-details
            :layoutTemplateId="scope.row.id"
            :dayOfWeek="scope.row.dayName"
            :code="scope.row.code"
            :name="scope.row.name"
            :layoutDate="scope.row.layoutDate"
          />
          <el-tooltip
            v-if="showDeleteButton(scope.row)"
            class="item"
            effect="dark"
            :enterable="false"
            :content="$t('common.delete')"
            placement="top-start">
            <i class="el-icon-delete icon-action" @click="handleDelete(scope.row)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-footer" v-show="layout.total > 0">
      <span class="el-pagination__total" slot>
        <span class="el-pagination__title" slot>{{ $t('layout.totalLayouts') }}</span>
        {{ layout.total }}
      </span>
      <el-pagination
        @size-change="handleSearchChangeLimit"
        :page-sizes="sizes"
        :page-size="layout.actualFilters.rows"
        :current-page.sync="layout.actualFilters.page"
        @current-change="handleSearchChangePage"
        :total="layout.total"
        layout="slot, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import constants from '@/utils/constants';
import ViewDetails from './components/ViewDetails';

export default {
  name: 'LayoutSearchSummary',
  components: {
    ViewDetails
  },
  computed: {
    ...mapGetters(['layout']),
    dateDisplayFormat() {
      return constants.DATES.DEFAULT_DISPLAY_FORMAT;
    }
  },
  data() {
    return {
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES
    };
  },
  methods: {
    handleSearchChangePage(val) {
      this.$store.dispatch('layout/search', { page: val });
    },
    handleSearchChangeLimit(val) {
      this.$store.dispatch('layout/search', {
        rows: val,
        page: constants.TABLES.DEFAULT_PAGE
      });
    },
    isActiveTooltipText(row) {
      if (row.activeForReceiving && row.activeForOutbound) {
        return this.$t('layout.receiving').concat(' / ').concat(this.$t('layout.outbound'));
      }
      if (row.activeForReceiving) {
        return this.$t('layout.receiving');
      }
      return this.$t('layout.outbound');
    },
    handleDelete(row) {
      const message = this.$t('layout.deleteConfirmMessage')
        .replace('[date]', moment(row.layoutDate).format(this.dateDisplayFormat))
        .replace('[dayOfWeek]', row.dayName)
        .replace('[templateSize]', row.code)
        .replace('[templateName]', row.name)
        .replace('[positionsAssigned]', row.positionsAssigned);
      this.$confirm(message, { dangerouslyUseHTMLString: true, confirmButtonText: this.$t('common.delete') })
        .then(() => {
          this.deletePosition(row);
        }).catch(() => {});
    },
    deletePosition(row) {
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      this.$store.dispatch('layout/delete', row.id).then((response) => {
        loading.close();
        this.$store.dispatch('layout/search', {});
        this.$message.success(response.message);
      })
        .catch(() => {
          loading.close();
        });
    },
    showDeleteButton(row) {
      return !(row.activeForReceiving || row.activeForOutbound)
          && this.$can(this.permissions.WAREHOUSE.DELETE_LAYOUTS);
    }
  }
};
</script>
